if (!customElements.get('speakon-home-privacy')) {
  customElements.define('speakon-home-privacy', class extends HTMLElement {
    connectedCallback() {
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      if (this.dataset.animate !== 'true' || reduced.matches || !window.IntersectionObserver) return;
      this.events = new AbortController();
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.remove('is-pending');
          this.observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -32px 0px' });
      this.querySelectorAll('[data-privacy-reveal]').forEach(element => {
        element.classList.add('is-pending');
        this.observer.observe(element);
      });
      reduced.addEventListener('change', () => {
        if (reduced.matches) this.show();
      }, { signal: this.events.signal });
      this.addEventListener('shopify:block:select', () => this.show(), { signal: this.events.signal });
    }

    show() {
      this.observer?.disconnect();
      this.events?.abort();
      this.querySelectorAll('.is-pending').forEach(element => element.classList.remove('is-pending'));
    }

    disconnectedCallback() { this.show(); }
  });
}
